import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—July 2008" />
	<Old2005BlogPage>
		<h2>July 2008</h2>



		<h3 className="blogdate">
		Wednesday, July 23, 2008
		</h3>






		<h4 className="blogitemtitle">
		I love movies
		</h4>





		   <div className="blogitembody">
		   <p>Sometimes I wonder if I'd be writing more songs if I watched less movies... Ah, but movies are so inspiring!  Books, too.  But this is about movies.<br /></p><p>In the past couple years, while living in New Zealand, I've watched a good share of movies.  Some Kiwi made (like <em>Eagle vs Shark</em> - a goodie - and <em>Scarfie</em>s, <em>Out of the Blue</em>...), and some foreign films.</p>I thought I'd share my top 7.  Two of them are old, which I'll comment on.  But they're all great movies, so if you're looking for something to watch, try one of these. Who am I kidding? You've probably seen them already.<br /><ol><li>Das Leben der Anderen (The Lives of Others) (2006, Germany)<br /></li><li>Eden (2006, Germany)<br /></li><li>Amadeus (1984, USA) - I was too young to appreciate this film when I first saw it... but now I love it.<br /></li><li>Adams æbler (Adam's Apples) (2005, Denmark)<br /></li><li>Once (2006, Ireland)<br /></li><li>La Science des Rêves (The Science of Sleep) (2006, France)<br /></li><li>A Beautiful Mind (2001, USA) - I've never seen it till this year - oooooh I love a good twist - plus I love anything to do with mathematics!<br /></li></ol>
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 8:58 PM &nbsp;
		   </div>






		<h3 className="blogdate">
		Tuesday, July 15, 2008
		</h3>






		<h4 className="blogitemtitle">
		Aerosmith a.k.a. The Inventures
		</h4>





		   <div className="blogitembody">
		   This is mystifying.  There is a website called globalinventure.com and it is totally whacky.  Without wasting too much of my time, I've noticed two very peculiar things.<br /><br />First go <a href="http://www.globalinventure.com/folk/folk_blues/jesse_rivest_seventeen_oh-two_oh-six.html">here</a>.  It's the very first bio I (must have) put on CDBaby for my CD, Seventeen Oh-Two Oh-Six.  Probably this site is a mirror of an old snapshot of CDBaby, as I no longer use that bio, and there are countless other similar pages for other artists/CD's.  Also, who are those South-Park-looking characters at the top of the page?<br /><br />Well, go <a href="http://www.globalinventure.com/index.html">here</a>.  Those South-Park-looking characters are... Aerosmith!?  While you're there, click on the links at the top:  Home, About Us, News, and Future.  It's all about Aerosmith, except they're called "The Inventures".  Very weird.<br /><br />Anyways, don't waste any more time looking at it.  I'm not even gonna waste any more time writing about it.  We need to be very efficient - time is not to be wasted.
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 5:32 PM &nbsp;
		   </div>






		<h3 className="blogdate">
		Saturday, July 12, 2008
		</h3>






		<h4 className="blogitemtitle">
		Homesickness
		</h4>





		   <div className="blogitembody">
		   When I first left Canada to travel in 2005, I marvelled at how I seemed impervious to homesickness.  Every month away seemed like a prize or a gift.  I was heard to say that I was having the best time of my life.  I was away about 9 months - the accumulation of which seemed a blissful eternity - and my return to Canada was for musical reasons, not from homesickness.<br /><br />Once back home, I was restless and anxious to leave again.  And so I did, after about 8 months.  Since then, I've essentially been in one place - Wellington, New Zealand.  The first year here was mostly exciting - I adjusted to the different weather and climate, and I dived into the culture and music.  I felt that I'd like to stay longer, so I did.<br /><br />It is now pushing two years of being away, and I've noticed a growing confusion, and a longing for Canada, and North America in general.  The confusion results, in part, from setting up a home - a place to live - away from the environment that I've always known to be home.  Once I did this, I grew to realize that I was no longer travelling - and the question "how long is this for?" appeared.  And I haven't been able to produce an answer to that.  I won't go into the various complexities involved.<br /><br />I often think of my friends in Canada; I miss them.  I sat down and wrote their names, their full names, and the names of their partners, and their children's names - if I could remember them.  Many of these friends I've known for nearly 15 years.  Some of them only a few years - yet in some cases we managed to form bonds as strong as those of longer friendships.  Writing this list was bittersweet - I'm happy to remember and cherish people, and I'm sad that we are so distant - literally and figuratively.<br /><br />I've grown homesick.  Missing friends, growing out-of-touch with family, longing for the Canadian and North American environment - this is it - homesickness.  New Zealand is a beautiful place (from the small bits I've actually seen), and Wellington is a very happening city.  Yet I have to work at appreciating where I am and the things that I've accomplished.  I almost daily take a walk and feel some peace from my environment - I have it pretty good here.  But a great deal of the time I feel a default confusion and longing - a displacement.  How long is this for?<br /><br />I'll discover the answer when I'm ready.  Meanwhile, I will officially (anything on my blog is official, ha ha) admit that I am homesick.  I miss you Canada.  I miss you, North America.  Please don't reject me, for I have not rejected you.<br /><br />Oh yeah, p.s. please find my podcast from my website, listen to it, like it, and tell your friends about it.  Done.
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 1:53 PM &nbsp;
		   </div>






		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
